import React from 'react'
// Components
import RealTimeMainSection from './RealTimeMainSection'
import BookNowCta from '../cta/BookNowCta'

function RealTimePageMainContainer() {
  return (
    <main
    role='main'
    className='grid pt-20 pb-12 md:pt-28 lg:pt-36 full_shadow_black_invert'
  >
    {/* Main section */}
    <RealTimeMainSection />

    {/* Cta */}
    <BookNowCta />

  </main>
  )
}

export default RealTimePageMainContainer